module.exports = __webpack_public_path__ + "img/icon-rueckgaberecht-schwarz.b25448c3.svg";